import { Component, OnInit } from "@angular/core";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

@Component({
	selector: "app-role-admin-su",
	templateUrl: "./role-admin-su.component.html",
	styleUrls: ["./role-admin-su.component.css"],
})
export class RoleAdminSUComponent implements OnInit {
	constructor(private selectService: SchoolselectorService) {}

	ngOnInit(): void {
		this.SelectedOption = this.lstOption[0];

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////

	subscription: any;

	SelectedOption: any;
	lstOption: any = [
		{
			ID: 1,
			Desc: "Schools and Role Counts",
		},
		{
			ID: 2,
			Desc: "District Level Users",
		},
		{
			ID: 3,
			Desc: "Users By Role",
		},
		{
			ID: 4,
			Desc: "Users Assigned to Multiple Schools",
		},
		{
			ID: 5,
			Desc: "Users with No Roles",
		},
		{
			ID: 6,
			Desc: "Users Assigned to Inactive Staff",
		},
	];

	SelectedRole: any;
	lstRole: any = [];

	SchoolOption: any;
	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	Processing: boolean = false;

	////////////////////////////////////////////////////

	////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.SchoolOption = val;
	}

	////////////////////////////////////////////////////

	////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////

	IsLoading() {
		return this.Processing == true;
	}

	////////////////////////////////////////////////////
}
